import { useEffect } from "react";

/**
 * Updates the page's `<link rel="canonical">` href to the given path.
 *
 * The canonical tag is defined once in index.html with a default value.
 * This hook overrides it per-route so search engines and AI crawlers receive
 * the correct canonical URL for each page, preventing duplicate-content issues
 * caused by URL variants (trailing slashes, UTM params, etc.).
 *
 * @param path - Absolute path for this page, e.g. `'/faq'`. The full URL is
 *               constructed as `https://fearlessleague.com{path}`.
 */
export default function useCanonical(path: string) {
    useEffect(() => {
        const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (canonical) canonical.href = `https://fearlessleague.com${path}`;
    }, [path]);
}
